"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastDismissButtonStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _ToastAction = require("../components/ToastAction");
const ToastDismissButtonStyled = (0, _styled.default)(_ToastAction.ToastAction)`
    padding: 4px;
`;
exports.ToastDismissButtonStyled = ToastDismissButtonStyled;
//# sourceMappingURL=ToastDismissButtonStyled.js.map